import React from 'react'
import Header from './components/header/Header'
import Streampacks from './components/streampacks/Streampacks'
// import Faqs from './components/faqs/Faqs'
import Comments from './components/comments/Comments'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'
import Recent from './components/recent/Recent'
import { Component } from 'react'

// const Home = () => {
//   return (
//     <div>Home</div>
//   )
// }

class Home extends Component {
    render() {
      return (
        <div>
          
          <Header />
          <Recent />
          <Streampacks />
          {/* <Faqs /> */}
          <Comments />
          <Contact />
          <Footer />
        </div>
      );
    }
  }


export default Home
